;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/:slug*\",\"regex\":\"^/([^/]+)/(.+)$\",\"paramNames\":[\"locale\",\"slug\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/new-eden-map\",\"regex\":\"^/([^/]+)/new-eden-map$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/testing-error\",\"regex\":\"^/([^/]+)/testing-error$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.1";globalThis["_sentryRewritesTunnelPath"] = "/monitoring-tunnel";import { getDistName, getSentryRelease } from '@/helpers/sentry/get-dist-name'
import * as Sentry from '@sentry/nextjs'

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN
const environment = process.env.NEXT_PUBLIC_ENVIRONMENT || 'production'

Sentry.init({
  dsn: SENTRY_DSN,
  environment,
  dist: getDistName(),
  release: getSentryRelease(),

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Adjust sample rates based on environment
  tracesSampleRate: environment === 'production' ? 0.2 : 1.0,
  replaysSessionSampleRate: environment === 'production' ? 0.1 : 1.0,
  replaysOnErrorSampleRate: environment === 'production' ? 1.0 : 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
